// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"P2-z","button":"Q2-z","disabled":"R2-z","creditCard":"S2-z","wrapper":"T2-z"};